import { NEWS_SUCCESS, NEWS_FAIL, LOAD_NEWS } from '../action.types';
import initialState from '../initial.state';

export default function(state = initialState.news, action) {
  switch (action.type) {
    case NEWS_SUCCESS:
      return { ...action.payload.data };
    case NEWS_FAIL:
      return state;
    case LOAD_NEWS:
      return { ...action.news };
    default:
      return state;
  }
}
